import Alert from "@mui/material/Alert";
import Snackbar from "@mui/material/Snackbar";
import { Component, ReactNode } from "react";

export interface NotificationMessage {
    message?: string;
    severity?: "success" | "info" | "warning" | "error" | "message";
    autoHideDuration?: number;
}

export interface NotificationProps {
    open: boolean;
    onClose: () => void;
    message?: NotificationMessage|null;
}

export class Notification extends Component<NotificationProps, any> {
    public render(): ReactNode {
        return (
            <Snackbar anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
                      open={this.props.open}
                      onClose={this.props.onClose}
                      message={this.props.message?.message}
                      autoHideDuration={this.props.message?.autoHideDuration}
                      children={(!this.props.open) ? undefined : (this.props.message?.severity === "message") ? undefined :
                              <Alert severity={this.props.message?.severity}
                                            variant="filled"
                                            sx={{ width: "100%" }}>
                                  {this.props.message?.message ?? undefined}
                              </Alert>
                      }
            />
        );
    }
}
